import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { TrimItemStyled } from '../TrimItemStyled';
import media from '../../../styles/media';
import { rem } from 'polished';

export const TrimItemStyledOV = styled(TrimItemStyled)`
    .trimContainer {
        .generalInfoContainer {
            .priceBox {
                display: flex;
                flex-direction: column;
                flex: auto;
            }
        }

        .equipmentList {
            @media (min-width: ${breakpoints.sm}px) {
                margin-top: ${rem('35px')};
            }

            &__info {
                font-family: ${({ theme }) => theme.fonts.fontBase};
                padding-left: ${rem('10px')};
                font-size: ${rem('16px')};
                font-weight: ${({ theme }) => theme.fontWeights.textMedium};
                color: ${({ theme }) => theme.colors.black};
            }

            &__list {
                list-style-type: none;
                font-size: ${rem('14px')};
                color: ${({ theme }) => theme.colors.black};
                font-family: ${({ theme }) => theme.fonts.fontSecondary};
                padding-left: ${rem('10px')};
            }

            &__list--item {
                font-family: ${({ theme }) => theme.fonts.fontSecondary};
                display: flex;
                align-items: center;
                &:not(:last-of-type) {
                    margin-bottom: ${rem('10px')};
                }
                &:first-of-type {
                    margin-top: ${rem('5px')};
                }
            }

            &__list--item::before {
                content: '';
                width: ${rem('4px')};
                min-width: ${rem('4px')};
                height: ${rem('4px')};
                display: inline-block;
                border-radius: 50%;
                background: ${({ theme }) => theme.colors.black};
                margin-right: ${rem('8px')};
                align-self: flex-start;
                margin-top: ${rem('8px')};
            }
        }

        .priceInfo {
            text-align: center;
            margin-top: ${rem('13px')};
            color: ${({ theme }) => theme.colors.grey22};
            .priceInfo__text {
                color: ${({ theme }) => theme.colors.grey22};
                font-size: ${rem('14px')};
                font-weight: normal;
                font-family: ${({ theme }) => theme.fonts.fontSecondary};
            }
            .priceInfo__clockIcon {
                @media (max-width: ${breakpoints.xs}px) {
                    display: none;
                }
            }
        }

        .priceWrap {
            &--price.OTR,
            .currencyLabel__suffix--OTR {
                font-size: ${rem(14)};
            }

            &--price,
            .currencyLabel__suffix--PM {
                font-size: ${rem(17)};
            }

            &--bonusLabel {
                font-size: ${({ theme }) => theme.fontSizes.h5};
            }
            &--bonusLink  {
                font-size: ${rem(14)};
            }
        }

        .header {
            font-family: ${({ theme }) => theme.fonts.fontSecondary};
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            .title {
                color: ${({ theme }) => theme.colors.black} !important;
                font-size: ${rem('21px')};
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            }
        }

        .equipmentSubtitle {
            p {
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                font-size: ${({ theme }) => theme.fontSizes.h5} !important;
                line-height: ${({ theme }) => theme.lineHeights.h4} !important;
                color: ${({ theme }) => theme.colors.grey22} !important;
                margin: ${rem('5px')} 0 ${rem('10px')} 0;
            }
        }

        .benefits {
            & > .heading {
                font-family: ${({ theme }) => theme.fonts.fontBase} !important;
                margin-bottom: ${rem('6px')};
                padding-left: ${rem('10px')};
                font-size: ${({ theme }) => theme.fontSizes.textMedium};
                color: ${({ theme }) => theme.colors.black2};
                font-weight: ${({ theme }) => theme.fontWeights.textMedium};
            }
            ul {
                list-style-type: none;
                li {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    font-family: ${({ theme }) => theme.fonts.fontSecondary} !important;

                    & > div:first-of-type {
                        width: 100%;
                    }

                    &::before {
                        content: '';
                        width: ${rem('4px')};
                        min-width: ${rem('4px')};
                        height: ${rem('4px')};
                        display: inline-block;
                        border-radius: 50%;
                        background: ${({ theme }) => theme.colors.black};
                    }

                    svg {
                        width: ${rem('15px')};
                        height: ${rem('15px')};

                        path {
                            fill: #888888 !important;
                        }
                    }
                }
            }
            .offer {
                justify-content: space-between;
                & > div:first-of-type {
                    margin-right: ${rem('12px')};
                }
            }
        }

        .buttonWrapper a {
            font-weight: bold;
            width: 100%;
            color: ${({ theme }) => theme.colors.black};
            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.white};
            }
        }

        .options {
            font-family: ${({ theme }) => theme.fonts.fontSecondary};
            padding-left: ${rem('8px')};

            .colorOption {
                display: flex;
                align-items: center;
                justify-content: flex-start;

                .colorButtonWrapper {
                    button {
                        border-color: transparent !important;
                        border-radius: 50%;
                        padding: 0;
                        background-size: cover;
                    }
                }
            }

            .engineOption {
                height: ${rem('30px')};
                width: ${rem('30px')};

                .engineText {
                    flex-wrap: nowrap;
                    > span {
                        min-width: ${rem('100px')};
                    }
                }
            }
        }

        .descriptionWrapper {
            font-family: ${({ theme }) => theme.fonts.fontSecondary};
            color: ${({ theme }) => theme.colors.grey1};
            font-size: ${rem('12px')};

            &-payment {
                padding-bottom: ${rem('10px')};
                font-size: ${rem('12px')};

                &-link {
                    padding-left: ${rem('5px')};
                    color: ${({ theme }) => theme.colors.grey1};
                    text-decoration: underline;
                    cursor: pointer;
                }
            }
        }

        .tooltip > div:last-child {
            left: 58% !important;
            right: -60% !important;

            &::after {
                left: ${rem('20px')};
                border-bottom: none !important;
                top: -3px;
            }
            ${media.md`
                left: 58% !important;
            `}
        }

        .carImageWrap {
            margin-top: ${rem('15px')};
            margin-bottom: ${rem('15px')};
        }
    }
`;
